import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  Button,
  Card,
  CardActions,
  CardContent, Dialog, DialogActions, DialogContent, DialogContentText,
  FormControlLabel,
  Switch
} from '@material-ui/core'

import ViewList from '../../components/common/ViewList'
import {EventAuctions, useFetchEventData} from '../../queries/events/useFetchEvents'
import styles from './HomePage.module.css'
import {getConfig} from "../../AppConfig";
import {
  useEditEventSettings,
  useUpdateEventClone,
  useUpdateEventStatus
} from "../AuctionSettingsForm/useEditEventSettings";
import {useFetchOrgSettings} from "../OrgSettingsPage/useFetchOrgSettings";
import {OrgState, setOrg} from "../../slices/orgSlice";
import {useDispatch} from "react-redux";
import {useAuthToken} from "../../slices/authSlice";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import * as events from "events";
import {useQueryClient} from "react-query";
import axios from "axios";
import { hasSavedAuctionSettings } from '../../util/auctionSetup'

const HomePage = () => {
  let { data } = useFetchEventData()
  const queryClient = useQueryClient()
  const editMutation = useEditEventSettings()
  const editStatusMutation = useUpdateEventStatus()
  const editCloneMutation = useUpdateEventClone()
  const [validAuction, setValidAuction] = useState(true)
  const [validEvent, setValidEvent] = useState(true)
  const [newbuttontext, setnewbuttontext] = useState('')
  const [eventAuctionsData, setEventAuctionsData] = useState<EventAuctions[]>(null)
  const localActiveOnly = localStorage.getItem('activeOnly')
  const history = useHistory()
  const dispatch = useDispatch()
  const [dialogMsg, setDialogMsg] = React.useState("");
  const [errorDialogMsg, setErrorDialogMsg] = React.useState("");
  const [dialogActivateMsg, setActivateDialogMsg] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const [activeEvent, setActiveEvent] = React.useState({eventid: 0, active: true});
  const [dialogCloneMessage, setDialogCloneMsg] = React.useState<string>("");
  const authToken = useAuthToken()
  const { data: settings } = useFetchOrgSettings({ userid: authToken?.userid })
  const { auctionSnapURL } = getConfig()

  useEffect(() => {
    return () => {
      setTimeout(() => {
        setIsLoading(true)
        setEventAuctionsData(null)
        data = null
        queryClient.invalidateQueries(['events'])
        queryClient.invalidateQueries(['eventdata'])
        const orgState: OrgState = {
          name: '', message: '', isdonorsnapcustomer: false, twilio: ''
        }
        dispatch(setOrg(orgState))
      })
    }
  }, [])

  useEffect(() => {
    if (data?.validauction || data?.validevent) {
      if (data?.validevent && data?.validauction) {
        document.title =  'AuctionSnap - EventSnap';
      }
      else if (data?.validevent) {
        document.title =  'EventSnap';
      }
      else if (data?.validauction) {
        document.title =  'AuctionSnap';
      }
    }
  }, [data]);

  useEffect(() => {
    if (settings) {
      const orgState: OrgState = {
        name: settings?.name, message: settings?.message, isdonorsnapcustomer: settings?.isdonorsnapcustomer, twilio: settings?.twilio
      }
      dispatch(setOrg(orgState))
    }
  }, [settings])

  const handleChange = (checked) => {
    localStorage.setItem('activeOnly', checked)

    if (data && data.eventauctions) {
      const filteredEvents = (checked ? data?.eventauctions?.filter((e) => e.active === true) : data.eventauctions)
      setEventAuctionsData(filteredEvents.map((eventItem) => {
        return {...eventItem}
      }))
    }
    else {
      setEventAuctionsData(null)
    }
  }

  const closeDialog = () => {
    setErrorDialogMsg('')
    setDialogMsg("")
    setActivateDialogMsg("")
    setDialogCloneMsg("")
  }

  const deleteDialog = async () => {
    const { data } = await axios.delete(`events`, {data: {
        // delete: true,
        eventid: activeEvent.eventid
      }})
    const parsedData = JSON.parse(data.jsonString)
    if (parsedData?.status == "failure") {
      setDialogMsg('')
      setErrorDialogMsg(parsedData?.message)
    }
    else {
      queryClient.invalidateQueries(['eventsettings'])
      queryClient.invalidateQueries(['events'])
      queryClient.invalidateQueries(['eventdata'])
      setDialogMsg("")
    }
  }

  const cloneContinueDialog = () => {
    editCloneMutation.mutate(
        {
          eventid: activeEvent.eventid
        }, {
      onSuccess: (data) => {
        const json = JSON.parse(data.data.jsonString)
        if (json.status === 'failure') {
          setDialogMsg(json.message)
        }
        else {
          setDialogCloneMsg("")

          const type = validEvent ? '/event/' : '/auction/'
          const eventPath = type + json.eventid
          history.push(eventPath)
          const eventPathSettings = type + json.eventid + '/settings'
          history.push(eventPathSettings)
        }
      }
    }
    )
  }

  const activateDialog = () => {
    editStatusMutation.mutate({
      // active: !activeEvent.active,
      eventid: activeEvent.eventid
    })
    setActivateDialogMsg("")
  }

  useEffect(() => {
    if (data && data.newbuttontext) {
      setnewbuttontext(data.newbuttontext)
    }

    if (data) {
      setValidAuction(data.validauction)
      setValidEvent(data.validevent)
    }

    if (data && data.eventauctions) {
      const filteredEvents = ('true' === localActiveOnly ? data?.eventauctions?.filter((e) => e.active === true) : data.eventauctions)
      setEventAuctionsData(filteredEvents.map((eventItem) => {
        return {...eventItem}
      }))
    }
    else {
      setEventAuctionsData(null)
    }
    setIsLoading(false)
  }, [data])

  return (
  <div className={styles.root}>
    <LoadingBackdrop open={isLoading} />
    <>
      <Dialog
          open={dialogCloneMessage.length > 0}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Clicking the continue button will clone the full event.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button onClick={cloneContinueDialog}>Continue</Button>
        </DialogActions>
      </Dialog>
    </>
    <>
      <Dialog
          open={dialogMsg.length > 0}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button onClick={deleteDialog}>Delete</Button>
        </DialogActions>
      </Dialog>
    </>
    <>
      <Dialog
          open={errorDialogMsg.length > 0}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorDialogMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Ok</Button>
        </DialogActions>
      </Dialog>
    </>
    <>
      <Dialog
          open={dialogActivateMsg.length > 0}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogActivateMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button onClick={activateDialog}>Yes</Button>
        </DialogActions>
      </Dialog>
    </>

      <div className={styles.topRow}>
        <Button
          variant="contained"
          className={styles.successBtn}
          onClick={() => {
            var eventorauctionurl = 'auctionnew'
            if (validEvent && validAuction) {
              // Both subscriptions: set up the event and auction together on one page
              eventorauctionurl = 'auctioneventnew'
            }
            else if (validEvent) {
              eventorauctionurl = 'eventnew'
            }
            history.push(eventorauctionurl)
          }}>
          Add New {newbuttontext}
        </Button>
        <FormControlLabel
          label={'Show Only Active'}
          labelPlacement="start"
          control={
            <Switch
              color="primary"
              defaultChecked={'true' === localStorage.getItem('activeOnly')}
              classes={{ switchBase: styles.switchBase }}
              onChange={(event) => {handleChange(event.target.checked)}}
            />
          }
        />
      </div>


    {eventAuctionsData?.map((event, i) => {
      const eventId = event.eventid
      const auctionPath = 'auction/' + eventId
      const eventPath = 'event/' + eventId
      let liValues = event.eventdetail.map((ed) => {
        return {
          label: ed.title,
          value: ed.value,
          title: ed.title,
          hover: ed.hover,
          islink: ed.islink,
          isprocessorlink: ed.isprocessorlink,
          aligntitle: ed.aligntitle,
          alignvalue: ed.alignvalue,
          widthtitle: ed.widthtitle,
          widthvalue: ed.widthvalue,
          eventname: event.eventname,
          eventid: event.eventid,
          active: event.active,
        }
      })

      return (

          <Card key={i} style={{display: 'grid'}}>
            {!isLoading &&
                <>
                  <CardContent style={{paddingLeft: '8px', paddingRight: '0px'}}>
                    <h2>{event.eventname}</h2>
                    <ViewList values={liValues} numOfCols={1}/>
                  </CardContent><CardActions className={styles.cardActions}>
                    {validAuction &&
                        <>
                          <Button
                              size="small"
                              variant="contained"
                              className={styles.successBtn}
                              onClick={() => {
                                // First visit goes to Auction Settings; saving there lands on the dashboard
                                history.push(hasSavedAuctionSettings(eventId) ? auctionPath : auctionPath + '/settings')
                              }}>
                            Auction
                          </Button>
                        </>}
                    {validEvent &&
                        <Button
                            size="small"
                            variant="contained"
                            className={styles.successBtn}
                            onClick={() => {
                              history.push(eventPath)
                            }}>
                          Event
                        </Button>}
                    <Button
                        size="small"
                        variant="contained"
                        className={styles.cloneBtn}
                        onClick={() => {
                          setActiveEvent({eventid: event.eventid, active: event.active})
                          setDialogCloneMsg("clone")
                        }}>
                      Clone
                    </Button>
                    <Button
                        onClick={() => {
                          setActiveEvent({eventid: event.eventid, active: event.active})
                          const message = (event.active ? "Are you sure you want to disable this event?" : "Are you sure you want to enable this event?")
                          setActivateDialogMsg(message)
                        }}
                        size="small"
                        variant="contained"
                        className={styles.deleteBtn}>
                      {event.active && "Disable"}
                      {!event.active && "Enable"}
                    </Button>
                  </CardActions><CardActions className={styles.cardActions}>
                    {!event.active &&
                        <Button
                            onClick={() => {
                              setActiveEvent({eventid: event.eventid, active: event.active})
                              setDialogMsg("Are you sure you want to delete this event?")
                            }}
                            size="small"
                            variant="contained"
                            className={styles.deleteBtn}>
                          Delete
                        </Button>}
                  </CardActions>
                </>
            }
          </Card>
        )
      })}
    </div>
  )
}

export default HomePage
